module.exports = __webpack_public_path__ + "img/Instructions.1ebcc84c.png";